export default "__VITE_ASSET__rdwWZD$t__"